import cx from "classnames";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Provider
import {
  AppContext
} from "../../components/AppProvider";

// Utils

// UI
import { getCookie, isLogin } from "../../modules/utils/cookie";
import { Container } from "../Layout";
import { checkMsgCount, request551 } from "./PmrLayout";

import _priv_main_visual01 from "../../resources/images/sub/priv_main_visual01.jpg";
import _priv_main_visual02 from "../../resources/images/sub/priv_main_visual02.jpg";
import _priv_main_visual03 from "../../resources/images/sub/priv_main_visual03.jpg";
import _priv_main_visual04 from "../../resources/images/sub/priv_main_visual04.jpg";
import _priv_main_visual05 from "../../resources/images/sub/priv_main_visual05.jpg";

import _priv_main_chartimg01 from "../../resources/images/main/priv_main_chartimg01.jpg";
import _priv_main_chartimg02 from "../../resources/images/main/priv_main_chartimg02.jpg";
import _priv_main_chartimg03 from "../../resources/images/main/priv_main_chartimg03.jpg";
import _priv_main_chartimg04 from "../../resources/images/main/priv_main_chartimg04.jpg";

import IcTrtmtCircle from "../../resources/images/icon/trtmtData/card/Icon_trtmt_circle.svg";

import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";

export const SUBS = [
  { url: "/pmr/treatmentData", code: "TREATMENT", label: "진료자료" },
  { url: "/pmr/otherinspaction", code: "INSFECTION", label: "기타자료" },
  { url: "/pmr/treatEducation", code: "TREAT", label: "교육자료" },
  { url: "/pmr/proofRecipt", code: "MEDICAL", label: "제증명서류" },

  // { url: "/pmr/history", code: "VIDEO", label: "영상자료" },
  // { url: "/pmr/inspaction", code: "INSFECTION", label: "검사결과" },
  // { url: "/pmr/treatEducation", code: "TREAT", label: "교육자료" },
  // { url: "/pmr/medicalRecord", code: "MEDICAL", label: "의무기록" },
];

export const SubMenu = (props) => {
  const { code } = props;
  const { menuNewInfo } = useContext(AppContext);

  return (
    <div className="top-roundtab-contain" style={{ padding: "27px 20px 22px 20px" }}>
      <ul>
        {SUBS.map((m, i) => (
          <li key={"submenu" + i}>
            <div>
              <div>
                <Link
                  to={m.url}
                  className={cx({ on: code === m.code })}
                  style={{ paddingLeft: !menuNewInfo ? "12px" : "0px" }}
                >
                  {m.label}
                  {/* <img src={IcTrtmtCircle} /> */}
                  {m.code === "TREATMENT" && menuNewInfo.phr01 == "Y" && (
                    <img src={IcTrtmtCircle} style={{ paddingLeft: "5px" }} />
                  )}
                  {m.code === "INSFECTION" && menuNewInfo.phr02 == "Y" && (
                    <img src={IcTrtmtCircle} style={{ paddingLeft: "5px" }} />
                  )}
                  {m.code === "TREAT" && menuNewInfo.phr03 == "Y" && (
                    <img src={IcTrtmtCircle} style={{ paddingLeft: "5px" }} />
                  )}
                  {m.code === "MEDICAL" && menuNewInfo.phr04 == "Y" && (
                    <img src={IcTrtmtCircle} style={{ paddingLeft: "5px" }} />
                  )}
                </Link>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const RecentTrtmtEduData = (props) => {
  const { list } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const onClickRecentData = (trsmId) => {
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.sendTrsmId(userinfo.userToken, trsmId, window.location.href);
    } else {
      webkit.messageHandlers.sendTrsmId.postMessage(
        userinfo.userToken,
        trsmId,
        window.location.href
      );
    }
  };

  return (
    <div className="pr-section" onClick={() => onClickRecentData(list[0].trsmId)}>
      <div className="sub-title">
        <b>최근 교육자료(기타)</b>
      </div>

      <div className="etc-edu-box">
        <div>
          <div className="t-box">
            <span>{list[0].hpName}</span>
            {list[0].drName && <p>{list[0].drName} 전문의</p>}
          </div>
          <div className="date-area">
            {/* 2020.05.11(월) 06:20 */}
            {list[0].studyTime.substring(0, 4)}.{list[0].studyTime.substring(4, 6)}.
            {list[0].studyTime.substring(6, 8)} {list[0].studyTime.substring(8, 10)}:
            {list[0].studyTime.substring(10, 12)}
          </div>
          <div className="paper-area">
            {/* {list[0].pdhType === "2" && <img src={_priv_main_chartimg01} alt="" style={{width:"100%"}}/>} */}
            {/* {list[0].pdhType === "3" && <img src={_priv_main_chartimg02} alt="" style={{width:"100%"}}/>} */}
            {/* {list[0].pdhType === "4" && <img src={_priv_main_chartimg03} alt="" style={{width:"100%"}}/>} */}
            {/* {list[0].pdhType === "5" && <img src={_priv_main_chartimg04} alt="" style={{width:"100%"}}/>} */}
            <img src={_priv_main_chartimg02} alt="" style={{ width: "100%" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => {
  const { auth, userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);

  // msgCount
  const [msgCount, setMsgCount] = useState("");
  const [list, setList] = useState("");

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  useEffect(() => {
    // 이미지 메뉴 슬릭
    $(".priv-vis-slide").slick({
      arrows: false,
      dots: true,
      // centerMode: true,
      pauseOnFocus: false,
    });

    if (getCookie("phoneToken") && !auth && isLogin()) {
      request551(userinfo2, cfg, phonecfg, 1, "", "", "", "", 1, "N", setList);
    }
  }, []);

  useEffect(() => {
    checkMsgCount(userinfo, cfg, phonecfg, "9", "00000000", "99999999", setMsgCount);
  }, [msgCount]);

  useEffect(() => {
    userHabit(phonecfg, "PR100");
    // NativeAction(phonecfg, "statusColor", "#A5AEE4");
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="개인진료기록"
        msgCount={msgCount}
        container="container"
        goToUrl="/"
        color="purple"
      >
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu />
          {/* /subTabMenu */}

          <div className="sub-contents">
            {/* slickView */}
            <div className="pr-section">
              <div className="priv-visual-contain">
                <div className="priv-vis-slide">
                  <div>
                    <img src={_priv_main_visual01} alt="" />
                  </div>
                  <div>
                    <img src={_priv_main_visual02} alt="" />
                  </div>
                  <div>
                    <img src={_priv_main_visual03} alt="" />
                  </div>
                  <div>
                    <img src={_priv_main_visual04} alt="" />
                  </div>
                  <div>
                    <img src={_priv_main_visual05} alt="" />
                  </div>
                </div>
              </div>
            </div>
            {/* /slickView */}

            {/* menuView */}
            <div className="pr-section">
              <div className="priv-guide-ttbox">
                <p>
                  {userinfo.userName} 님의 진료교육자료, 영상자료, 제증명서류에
                  <br />
                  해당하는 개인진료기록을 편리하게 확인할 수 있습니다.
                </p>
              </div>
              <div className="priv-main-chartboxes">
                <div className="horizon-slide">
                  <ul>
                    <li>
                      <Link to="/pmr/history">
                        <img src={_priv_main_chartimg01} alt="" />
                        <div className="tit">영상자료</div>
                      </Link>
                    </li>

                    <li>
                      <Link to="/pmr/otherinspaction">
                        <img src={_priv_main_chartimg02} alt="" />
                        <div className="tit">입력자료</div>
                      </Link>
                    </li>

                    <li>
                      <Link to="/pmr/treatEducation">
                        <img src={_priv_main_chartimg03} alt="" />
                        <div className="tit">교육자료</div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/pmr/medicalRecord">
                        <img src={_priv_main_chartimg04} alt="" />
                        <div className="tit">의무기록</div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /menuView */}

            {/* recentDataView */}
            {list.length > 0 && <RecentTrtmtEduData list={list} />}
            {/* /recentDataView */}
          </div>
        </div>
      </Container>
    </Fragment>
  );
};
